import { render } from "./previewImageModal.vue?vue&type=template&id=484a323c&scoped=true"
import script from "./previewImageModal.vue?vue&type=script&lang=js"
export * from "./previewImageModal.vue?vue&type=script&lang=js"

import "./previewImageModal.vue?vue&type=style&index=0&id=484a323c&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484a323c"]])

export default __exports__